import * as request from '@/utils/request'

export default {
  /**
   * @description 提交登录信息，进行登录
   * @author YM
   * @date 2019-02-12
   * @returns
   */
  submitLoginInfo(data) {
    return request.post('/passport/login',data)
  },
  /**
   * @description 提交退出登录
   * @author YM
   * @date 2019-02-13
   * @returns
   */
  submitLogout() {
    return request.post('/passport/logout')
  },
  /**
   * @description 获取验证码
   * @author YM
   * @date 2019-02-13
   * @returns
   */
  getCode(data) {
    return request.post('/api/sms/send', data)
  },
  getLoginCode(data) {
    return request.post('/paas/sms/sendSms', data)
  },
  /**
   * 短信验证码校验
   * @param {*} data
   */
  verifyCode(data) {
    return request.post('/sms/verify', data)
  },
  /**
   * @description 短信验证码登录
   * @author YM
   * @date 2019-02-13
   * @returns
   */
  submitCodeLogin(data) {
    return request.post('passport/sms_login',data)
  }


}